import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Grid as VirtualizedGrid } from 'react-virtualized'

import styles from './grid-left-header.css'

const GridLeftHeader = ({ items, height, width, scrollTop, renderCell, calculateRowHeight, setRef }) => (
  <div styleName="container">
    <VirtualizedGrid
      cellRenderer={renderCell}
      columnCount={1}
      columnWidth={width}
      height={height}
      ref={setRef}
      rowCount={items.count()}
      rowHeight={calculateRowHeight}
      scrollTop={scrollTop}
      styleName="grid"
      width={width}
    />
  </div>
)

GridLeftHeader.propTypes = {
  items: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  renderCell: PropTypes.func.isRequired,
  calculateRowHeight: PropTypes.func.isRequired,
  setRef: PropTypes.func.isRequired,
}

export default CSSModules(GridLeftHeader, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-left-header/grid-left-header.js
 **/